import React from 'react'
import img2042 from '../components/images/lglowroad.png'

const events = () => {
    return (

        <>
            <div className="row  m-2">
                <img src={img2042} alt='glowroad' />
            </div>
            <div className="row m-2">
                <div className="col-sm ">

                    <h2 className='p-2'>GlowRoad Listing Services
                    </h2>
                    <p>Maximize your sales potential on GlowRoad with our tailored listing services designed to enhance visibility and drive growth. </p>
                </div>
                <div className="col-sm ">
                    {/* <img src={img201} alt='Queryimg' /> */}
                </div>
            </div>
            <ul >
                <h3 className='text-info'> Key Services :</h3>
                <li><b>•	Product Listing:</b>Optimize product listings with compelling descriptions, high-quality images, and strategic keywords for better visibility. </li>
                <li><b>•	Advertising Campaign:</b>Strategically plan and execute targeted ad campaigns to enhance product visibility and drive sales.</li>
                <li><b>•	Coupons:</b> Create and manage discount coupons to incentivize purchases and attract more customers. </li>
                <li><b>•	Brand Registry:</b>Assist brands in registering with GlowRoad’s Brand Registry to protect intellectual property and build brand credibility. </li>
                <li><b>•	Brand Approval:</b> Guide brands through the approval process to ensure compliance with GlowRoad’s standards. </li>
                <li><b>•	Category Approval:</b> Facilitate smooth approval for product categories, ensuring listings meet specific requirements. </li>
                <li><b>•	Account Health:</b>Monitor and maintain vendor account health to uphold GlowRoad’s policies and performance metrics. </li>
                <li><b>•	Order Processing:</b> Efficiently manage order processing from receipt to delivery, ensuring prompt and accurate fulfillment. </li>
                <li><b>•	Payment Reconciliation:</b> Oversee payment reconciliations to maintain accurate financial records and resolve discrepancies promptly.. </li>
                <li><b>•	Keyword Optimization:</b> Conduct thorough keyword research and optimize listings to improve search rankings and visibility. </li>
                <li><b>•	Safety Claim:</b>Address product safety concerns promptly, ensuring compliance with safety standards.</li>
                <li><b>•	Basic Training:</b>Provide essential training on GlowRoad tools and features to enhance seller proficiency. </li>
                <li><b>•	Sales Boost:</b> Implement effective strategies to boost sales through improved listings, promotions, and optimized advertising efforts.</li>
            </ul>
        </>
    )
}

export default events